import { getRecordingS3IntakeSettings } from "@repo/app-types/entities/integration";
import type { FC } from "react";
import { Navigate } from "react-router";
import { RecordingImportsTab } from "./recordingImportsTab.js";
import {
  checkRecordingS3IntakeBucket,
  useRecordingS3IntakeDetailOutletContext,
} from "./recordingS3IntakeIntegrationDetailSection.js";

/**
 * The **Failed imports** tab of the Recording S3 intake detail: the generic
 * recording-imports surface over this company's S3 integration row.
 */
export const RecordingS3IntakeImportsTab: FC = () => {
  const { integration } = useRecordingS3IntakeDetailOutletContext();
  // The detail frame offers no Failed imports tab for a row naming no bucket (the
  // API 404s it), so a deep link to one lands on the Settings tab instead.
  // ".." is the parent route: "." would resolve to this child and stay put.
  if (!checkRecordingS3IntakeBucket(integration)) {
    return <Navigate to=".." replace />;
  }
  // While Alpharun has paused intake nothing is actionable: the API refuses
  // both reprocess and skip (400), so the tab hides the actions instead.
  const isPaused = getRecordingS3IntakeSettings(integration)?.enabled === false;
  return (
    <RecordingImportsTab
      integrationId={integration.id}
      provider={integration.provider}
      isPaused={isPaused}
      description="Call recordings from your bucket that could not be imported. Reprocess a failed or skipped recording to try importing it again, or skip a failed one to dismiss it."
    />
  );
};
